/**
 * @file Configuration.js
 * For portal-wide JavaScript configuration.
 *
 * @author Brian Yao <brian@studyportals.com>
 * @author Nicola Meneghetti <nicola@studyportals.com>
 * @copyright © 2016 StudyPortals B.V., all rights reserved.
 * @version 1.1
 */
import Shared from './Shared';
Shared.live = true;

var Configuration = typeof Configuration === 'undefined' || Configuration == null ? {} : Configuration;

Configuration.Search =
	typeof Configuration.Search === 'undefined' || Configuration.Search == null ? {} : Configuration.Search;
Configuration.Search.apiUrl = 'https://search.prtl.co/2018-07-23/';
Configuration.Search.proxyUrl = 'https://1cna6fszvk.execute-api.eu-west-1.amazonaws.com/prod';
Configuration.autoCompleteURL = 'https://autocomplete.prtl.co/';

Configuration.snowplow = {
	app_id: 'prod',
	collectorSubdomain: 'collect'
};

export default Configuration;
